var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBelize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1b26",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#003e87",
    d: "M30 2v20H0V2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.62 2.77a9.23 9.23 0 1 0 0 18.46 9.23 9.23 0 0 0 0-18.46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#730900",
    d: "M14.62 3.7a8.3 8.3 0 1 0 0 16.6 8.3 8.3 0 1 0 0-16.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.62 3.93a8.07 8.07 0 1 0 0 16.14 8.07 8.07 0 0 0 0-16.14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b34b00",
    d: "m11.81 6.65.92 1.56h1l.45.36.28.96-1-.44.93.76-.22.76h.76V9.26l1.25-.76-.21-.16-1.03.58-.12-.84-.2-.2.64-.79-.32-.13-.48.7-.07-.57.07-.71s-.32-.26-.3-.17c.04.08 0 .63 0 .63l-.6-.65-.27.11.6.54-.7.52-.85-.23.16-.87h-.17l-.15.82-.15-.7-.22.38m3.22-.95h.2v.75h-.2zm1.05.15h.25v.4h-.25z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.92 7.53.16.44.97.1.4.42-.15-.48-.25-.56z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#289400",
    d: "M11.83 5.82c.58-.35.96.24.96.24s.24-.74.96-.79c.71-.05.7.27.7.27s.17-.46 1.12-.27.93.5.77.64c-.16.13-1.61.05-1.61.05s.15.28.16.4.54-.22 1.36 0c0 0 .4-.7 1.01-.34.62.37 1.02 1.07.87 1.27s-1.25.07-1.37-.07c0 0-.23.37-.75.3a5 5 0 0 1-1.38-.61l-.18-.27s-.4-.32-.88-.33c-.5-.02-.83 0-.83 0s-.33.38-.71.43c-.39.05-.79.03-.79.03s-.08-.54.59-.95"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#289400",
    d: "M12.5 6.89c.96-.15 1.6 0 1.66.47.07.46-.71.38-.87.4-.16.01-1.08.33-1.38.31-.3-.01-.92-.31-.47-.75.45-.43 1.06-.43 1.06-.43m3.68.85c.94.22 1.38.73 1.17.95-.22.22-.78.18-1.28 0s-1.21-.05-1.37-.4c-.15-.35.4-.8 1.48-.55m-.32 1.2c.71.12.74.75.62.87s-1.22-.04-1.47-.34.14-.65.84-.53m-2.66-.32c.9-.33 1.28.05 1.27.4s-.76.34-1.06.47c-.29.14-.82.3-1 .1s.08-.7.8-.97"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#adadad",
    d: "M12.58 17.85c-.25.24-.63.76.18.91.8.16.5-.63.32-.77-.17-.13-.5-.14-.5-.14"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#69f",
    d: "M12.98 18.08c.02.05.12.28 0 .42a.6.6 0 0 1-.5.21s.78.13.95.22.31-.17.23-.52-.68-.33-.68-.33"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M18.08 16.46c-.43 0-1.02.35-1.02.35s-.26-.27-.7-.03c-.43.23-.68.3-.65.73 0 0-.23.12-.47.18-.36.1-.61.02-.61.02s-.25.09-.62-.02c-.23-.06-.46-.18-.46-.18.03-.43-.22-.5-.65-.73-.44-.24-.7.03-.7.03s-.59-.35-1.02-.35-.82.42-.8.54c.01.11.21.51.33.71s.22.32.53.32.99-.2.99-.2.15.15.93.45c.79.3 1.47.28 1.47.28s.68.02 1.46-.28c.79-.3.94-.45.94-.45s.67.2.98.2c.32 0 .42-.12.54-.32.11-.2.31-.6.33-.71.02-.12-.37-.54-.8-.54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#adadad",
    d: "M12.27 16.86c.32.22.99.53 1.28.65 0 0 .1-.28-.16-.44-.26-.17-.63-.31-.81-.39-.19-.07-.31.18-.31.18m.13.99c-.46-.4-.74-.55-1.07-.62s-.73.05-.71.3c0 .27.33.53.63.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#69f",
    d: "M12.4 16.96s.01-.32.23-.18c.21.13.15.37.15.37zm-.3.78s-.57-.41-.82-.41-.5.01-.49.2c.02.2.35.28.54.31.18.04.76-.1.76-.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#adadad",
    d: "M16.68 17.85c.25.24.63.76-.18.91s-.5-.63-.32-.77c.17-.13.5-.14.5-.14"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#69f",
    d: "M16.28 18.08c-.02.05-.12.28 0 .42a.6.6 0 0 0 .5.21s-.78.13-.95.22-.32-.17-.23-.52.68-.33.68-.33"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#adadad",
    d: "M16.99 16.86a9 9 0 0 1-1.28.65s-.1-.28.16-.44c.25-.17.63-.31.81-.39.18-.07.3.18.3.18m-.13.99c.45-.4.74-.55 1.07-.62s.72.05.71.3c-.01.27-.33.53-.63.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#69f",
    d: "M16.86 16.96s-.01-.32-.23-.18c-.22.13-.15.37-.15.37zm.3.78s.57-.41.82-.41.5.01.48.2c-.01.2-.35.28-.53.31-.18.04-.77-.1-.77-.1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#289400",
    d: "M10.04 15.03c.92-.19 5.07-.3 6.26-.15s3.77.86 3.43 1.28-1.77.38-2.58.25-1.14.59-2.52.6-2.09-.43-2.67-.65a3.4 3.4 0 0 0-1.92.05c-.5.15-2.15-.95 0-1.38"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.18 10.4v3.16c0 1.15.87 2.08 1.22 2.42.36.33 1.23.81 1.23.81s.86-.48 1.22-.81 1.23-1.27 1.23-2.42v-3.15z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ed7ff",
    d: "M12.43 10.6v2.96c0 1.04.78 1.98 1.1 2.28s1.1.73 1.1.73.78-.44 1.1-.73c.32-.3 1.1-1.24 1.1-2.28v-2.95z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#006ac8",
    d: "M13.19 15.46h2.88q.17-.21.34-.5h-3.56q.16.3.34.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#5ac800",
    d: "M13.19 15.46a3 3 0 0 0 .56.55h1.76a2 2 0 0 0 .56-.55z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd801",
    d: "M14.63 16.57s.52-.29.88-.56h-1.77c.37.27.89.56.89.56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.6 14.46 2.03-1.8V10.6h-2.2v2.95q0 .48.18.9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83c",
    d: "M16.65 14.46q.17-.44.18-.9v-2.95h-2.2v2.05z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#b34b00",
    d: "m14.34 12.3-.06-.03-.05.02-.07.07-.43-.44q.08-.12 0-.2l-.88-.87q-.1-.08-.22.04-.12.13-.04.22l.89.87q.06.05.15.02l.44.44-.09.1a.1.1 0 0 0 0 .1l.01.01q.05.04.11 0l.24-.24.02-.08z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#782121",
    d: "M12.92 12.76a.1.1 0 0 1-.1.03l-.04-.01a.1.1 0 0 1-.04-.11l.02-.04.95-1.24a.1.1 0 0 1 .1-.03l.04.02a.1.1 0 0 1 .04.1l-.02.04z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "m13.54 11.23.26-.42.56.35-.27.42z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#782121",
    d: "m16.46 12.6.07.04a.1.1 0 0 0 .08-.17l-1.05-1.15a.1.1 0 0 0-.17.06l.02.08z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.81 11.4.48-.46.34.36-.48.45zm.2.73 1.24-1.2.32.33-1.25 1.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#b34b00",
    d: "M13.4 14.4s.68.3 1.25.32c.58.02.73-.08.73-.08l-.17.32h-1.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.63 14.36.35.25h1.3l-.17-.87-1.13.06z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#892614",
    d: "M11.13 8.07c.38-.19 1.12-.6 1.23-.66.12-.06.3.16.13.24-.18.07-1.1.62-1.36.75-.27.12 0-.33 0-.33"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbd44d",
    d: "M9.78 15.38c-.05.36-.27.73.15.85.41.11.5-.27.38-.62s-.53-.23-.53-.23m1.45-.02c-.07.15-.27.49.13.44s.65-.04.9 0 .4-.23.13-.22q-.4.03-.56-.33c-.1-.25-.6.1-.6.1m-.98-4.6-.12-.65s-.34.34-.45.5c-.12.17-.35-.07-.48-.18-.14-.1-.29-.44-.32-.72-.03-.29-.37-.45-.25-.65s.22-.3.42-.3.25.27.25.27.38.04.23.23c-.38.45-.08.53-.08.53l.23-.28s-.09-.53 0-.63.58-.29.75-.3.37-.17.29-.27c-.07-.1-.24-.29-.24-.5s-.08-.69.41-.62.66.38.52.65c-.13.27-.2.35-.15.5s.07.33.4.35c.32.02.38.12.43.4s.06.44.04.67v.31s.3-.05.51-.02.67.3.67.3h-1.08l-.08.36s-.12.13-.17.12l-.33-.45-.12.45z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M10.16 10.71c-.18.4-.35 1.27-.32 1.73.04.47.13.95 0 1.38-.13.44-.31 1.67-.31 1.67l.46.32.52-.33.08-1.95.3-.97.29.7-.12 2.17.85-.02-.08-2.31a33 33 0 0 0-.3-2.27z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#9b5f00",
    d: "M10.2 10.63s.34.09.69.08c.37-.01.75-.13.75-.09.02.09 0 .37 0 .37s-.3-.06-.72 0c-.4.07-.58.05-.73 0s0-.37 0-.37"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11 6.92c.37 0 .53.29.52.59s-.11.38-.11.38.06-.32-.13-.17v-.31s-.42.03-.56 0l-.23-.07-.05.23s-.2-.23-.01-.45c.18-.21.49-.2.49-.2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#892614",
    d: "M8.19 9.65c.17-.25.47-.44.47-.44s.05.06.23 0 .16-.11.26-.15.1-.15.1-.15l.83-.35c.25-.12.54-.29.54-.29l.11.09s0 .19-.1.25-.85.44-.91.49-.2.1-.2.1-.07-.13-.13-.08-.1.19-.1.19-.25.11-.4.21-.32.45-.49.53c-.16.07-.27-.31-.21-.4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M11.79 7.65c.09-.1.43-.33.5-.2.09.12.21.8.61.75 0 0-.23.2-.43.3s-.56.13-.56.13v-.5c0-.2-.12-.48-.12-.48"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#b34b00",
    d: "M15.67 6.76c.13-.06 1.5.66 1.72.76.23.1.36.5.6.59.22.09.03.24-.1.16-.15-.07-.45-.05-.7-.14a10 10 0 0 1-1.72-.94c-.03-.12.2-.43.2-.43"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#892614",
    d: "M19.44 15.38c.05.36.27.73-.15.85s-.5-.27-.38-.62.53-.23.53-.23m-1.45-.02c.07.15.27.49-.13.44s-.66-.04-.9 0c-.26.04-.4-.23-.14-.22q.41.03.57-.33c.1-.25.6.1.6.1m.98-4.6.12-.65s.27.26.38.43c.12.17.4.19.52.08.14-.11.32-.63.35-.91s.35-.23.23-.43-.24-.33-.44-.33-.2.08-.2.08-.26.06-.16.28-.03.5-.03.5l-.2-.16s-.06-.64-.15-.74-.44-.32-.6-.34c-.17-.01-.37-.16-.3-.26s.25-.29.25-.5.08-.69-.41-.62c-.5.07-.66.38-.52.65.13.27.1.37.06.52s.02.31-.3.33c-.33.02-.44.19-.49.47-.05.29 0 .36.01.6v.31s-.3-.05-.52-.02c-.21.03-.67.3-.67.3H17l.08.36s.12.13.17.12.33-.45.33-.45l.12.45z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M19.06 10.71c.18.4.35 1.27.31 1.73-.03.47-.12.95 0 1.38.14.44.32 1.67.32 1.67l-.47.32-.51-.33-.09-1.95-.3-.97-.28.7.12 2.17-.85-.02.08-2.31c.02-.32.13-1.29.18-1.59l.12-.68z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#9b5f00",
    d: "M19.02 10.63s-.34.09-.7.08-.74-.13-.75-.09V11s.31-.06.72 0c.41.07.58.05.73 0s0-.37 0-.37"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.21 6.92c-.37 0-.53.29-.51.59s.1.38.1.38-.07-.32.13-.17v-.31s.42.03.56 0l.23-.07.06.23s.2-.23 0-.45c-.18-.21-.48-.2-.48-.2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#b34b00",
    d: "m18.5 8.27 1.37.74s-.19 0-.18.15c0 .16-1.12-.53-1.12-.53zm1.92 1.1.42.14s.05-.14.18-.07c.12.07-.06.63-.15.62s-.19-.15-.2-.26-.39-.27-.39-.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelize);
export default __webpack_public_path__ + "static/media/belize.029c974283fcca04e26fe57af55f451f.svg";
export { ForwardRef as ReactComponent };